import React, { useState } from 'react';
import './InfoIcon.css';

interface InfoIconProps {
  content: string;
  title?: string;
}

const InfoIcon: React.FC<InfoIconProps> = ({ content, title }) => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div className="info-icon-container">
      <button 
        className="info-icon-button"
        onClick={() => setShowInfo(!showInfo)}
        title={title || "Information anzeigen"}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 16v-4M12 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {showInfo && (
        <div className="info-icon-popup">
          <div className="info-icon-content">
            <button 
              className="info-close-button"
              onClick={() => setShowInfo(false)}
            >
              ×
            </button>
            <p>{content}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoIcon;